import { render, staticRenderFns } from "./W0115V0001.vue?vue&type=template&id=9697b95a&"
import script from "./W0115V0001.vue?vue&type=script&lang=js&"
export * from "./W0115V0001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports